import useCacheLlmRawDataEffect from './useCacheLlmRawDataEffect';
import { IChartLine } from '../useChartLines';
import { ISingleDateData } from '../useSingleDateData';
import { useMemo } from 'react';
import { MaybeNil } from '../../../../utils/interfaces';

interface IProps {
  analysisId: string;
  visibleLines: IChartLine[];
  data: ISingleDateData[];
  chartTypeName: string;
  singleDayLabel: MaybeNil<string>;
}

const useCacheSingleDateLlmRawDataEffect = ({
  analysisId,
  visibleLines,
  data,
  chartTypeName,
  singleDayLabel,
}: IProps) => {
  const rawData = useMemo(() => {
    const forSingleDayLabel = !!singleDayLabel
      ? `zoomed on ${singleDayLabel} `
      : '';
    const ret = [
      `The ${chartTypeName} chart ${forSingleDayLabel}was produced from the following data:`,
    ];
    ret.push(visibleLines.map((v) => v.display).join(','));
    ret.push(data.map((d) => d.value).join(','));
    return ret.join('\n');
  }, [singleDayLabel, chartTypeName, visibleLines, data]);

  useCacheLlmRawDataEffect({
    analysisId,
    rawData,
  });
};

export default useCacheSingleDateLlmRawDataEffect;
